import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Layout from '../components/Layout.vue'
import Home from '../views/Home.vue'
import CustomerList from '../views/CustomerList.vue'
import CustomerDetail from '../views/CustomerDetail.vue'
import CustomerForm from '../views/CustomerForm.vue'
import CustomerMap from '../views/CustomerMap.vue'
import CustomerRecycleBin from '../views/CustomerRecycleBin.vue'
import AddVisitRecord from '../views/AddVisitRecord.vue'
import EditVisitRecord from '../views/EditVisitRecord.vue'
import VisitRecordDetail from '../views/VisitRecordDetail.vue'
import UserList from '../views/UserList.vue'
import UserDetail from '../views/UserDetail.vue'
import DepartmentList from '../views/DepartmentList.vue'
import RoleList from '../views/RoleList.vue'
import MenuList from '../views/MenuList.vue'
import { isLoggedIn, isTokenValid, clearAuth } from '../utils/auth'
import { getAllowedPaths, fetchAllowedPaths, hasPathPermission } from '../utils/permission'
import { Message } from 'element-ui'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    name: 'Layout',
    component: Layout,
    meta: { requiresAuth: true },
    redirect: '/home',
    children: [
      { path: 'home', name: 'Home', component: Home },
      { path: 'customers', name: 'CustomerList', component: CustomerList },
      { path: 'customers/recycle-bin', name: 'CustomerRecycleBin', component: CustomerRecycleBin },
      { path: 'customers/new', name: 'AddCustomer', component: CustomerForm },
      { path: 'customers/:id', name: 'CustomerDetail', component: CustomerDetail, meta: { permissionPath: '/customers' } },
      { path: 'customers/edit/:id', name: 'EditCustomer', component: CustomerForm, meta: { permissionPath: '/customers' } },
      { path: 'map', name: 'CustomerMap', component: CustomerMap },
      { path: 'visit-records/new', name: 'AddVisitRecord', component: AddVisitRecord, meta: { permissionPath: '/customers' } },
      { path: 'visit-records/edit/:id', name: 'EditVisitRecord', component: EditVisitRecord, meta: { permissionPath: '/customers' } },
      { path: 'visit-records/:id', name: 'VisitRecordDetail', component: VisitRecordDetail, meta: { permissionPath: '/customers' } },
      { path: 'users', name: 'UserList', component: UserList },
      { path: 'users/:id', name: 'UserDetail', component: UserDetail, meta: { permissionPath: '/users' } },
      { path: 'departments', name: 'DepartmentList', component: DepartmentList },
      { path: 'roles', name: 'RoleList', component: RoleList },
      { path: 'menus', name: 'MenuList', component: MenuList }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})

// 路由守卫：认证 + 菜单权限（防止通过地址栏绕过菜单访问无权限页面）
router.beforeEach(async (to, from, next) => {
  if (!to.matched.some(record => record.meta.requiresAuth)) {
    next()
    return
  }
  if (!isLoggedIn()) {
    next({ path: '/login' })
    return
  }
  if (!isTokenValid()) {
    Message.error('登录已过期，请重新登录')
    clearAuth()
    next({ path: '/login' })
    return
  }
  // 菜单权限：无该菜单权限则不能通过直接输入地址访问
  let paths = getAllowedPaths()
  if (!paths || !paths.length) {
    paths = await fetchAllowedPaths()
  }
  const routePath = to.path
  const metaRecord = to.matched.find(r => r.meta && r.meta.permissionPath)
  const permissionPath = metaRecord ? metaRecord.meta.permissionPath : null
  if (!hasPathPermission(routePath, permissionPath)) {
    Message.error('没有权限访问该页面')
    next({ path: '/home' })
    return
  }
  next()
})

export default router